var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup162893(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_162893",
    "data-name": "Group 162893",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.348,
    height: 22.348,
    viewBox: "0 0 22.348 22.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    fill: "#fdfdfd",
    stroke: "#dadada",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.174,
    cy: 11.174,
    r: 11.174,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.174,
    cy: 11.174,
    r: 10.924,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_keyboard_arrow_right_24px",
    d: "M0,5.26,2.275,2.98,0,.7.7,0,3.68,2.98.7,5.96Z",
    transform: "translate(14.154 10.654) rotate(90)",
    fill: "#1b1c1d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162893);
export default __webpack_public_path__ + "static/media/Group 162893.31852dc6476475a823ee832482eeed72.svg";
export { ForwardRef as ReactComponent };